import React, { useEffect, useState } from "react";
import { Stage, Layer, Image } from "react-konva";
import Rectangle from "./ReadRect";
import Icon from "../Icon";

function ReadCanvas(props) {
  const {
    background,
    canvasWidth,
    canvasHeight,
    scale,
    stageRef,
    bgRef,
    rects,
    setRects,
    points,
    fill,
    opacity,
    seek,
    currentTime,
    duration,
    setActiveRect,
    pageId,
  } = props;
  const [pageMap, setPageMap] = useState();

  let findRect = {};

  useEffect(() => {
    let temp = rects.slice();

    temp = temp.sort((a, b) => {
      return a.startTime - b.startTime;
    });

    temp = temp.map((r, i) => {
      return {
        ...r,
        id: i,
      };
    });

    setRects(temp);

    // using a map might be a little cheaper than searching through all the rects during play, but I haven't tested this
    setPageMap(
      temp.map((r) => {
        return {
          id: r.id,
          startTime: r.startTime,
          pauseAfter: r.pauseAfter,
        };
      })
    );
  }, [pageId]);

  // useEffect(() => {
  //   console.log("pageMap:", pageMap);
  // }, [pageMap]);

  // This useEffect will run every time currentTime is updated
  // (the frequency is set by progressInterval of the ReactPlayer component in App.js).
  // Its purpose is to determine the currently active rect based on the startTime of it and the next one,
  // as compared to currentTime.
  //
  // If the find() function should return undefined, activeRect is simply set to the last one in the array.
  useEffect(() => {
    if (pageMap) {
      findRect =
        // eslint-disable-next-line react-hooks/exhaustive-deps
        currentTime >= rects[rects.length - 1].startTime
          ? rects[rects.length - 1]
          : rects[pageMap.find((r) => r.startTime > currentTime).id - 1];
      setActiveRect(findRect);
    }
  }, [currentTime]);

  return (
    <div className="canvas">
      <Stage scale={scale} ref={stageRef} width={canvasWidth} height={canvasHeight}>
        <Layer>
          <Image image={background} ref={bgRef} />
        </Layer>
        <Layer>
          {rects.map((rect, index) => {
            return (
              <Rectangle
                key={index}
                index={index}
                id={String(index)}
                x={rect.x}
                y={rect.y}
                draggable={false}
                width={rect.width}
                height={rect.height}
                startTime={rect.startTime}
                endTime={index < rects.length - 1 ? rects[index + 1].startTime : duration}
                seekTime={rect.startTime}
                seek={seek}
                fill={fill}
                opacity={opacity}
                rect={rect}
                currentTime={currentTime}
                setActiveRect={setActiveRect}
              />
            );
          })}
          {points.map((point) => {
            return (
              <Icon
                id={point.id}
                key={point.id}
                x={point.x}
                y={point.y}
                iconUrl={point.iconUrl}
                // customText={point.customText}
                color={point.color}
                draggable={false}
                scale={point.scale}
              />
            );
          })}
        </Layer>
      </Stage>
    </div>
  );
}

export default ReadCanvas;
